module.exports = "<p>\n  static-contact works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/static-contact/static-contact.component.html
// module id = ../../../../../src/app/static-contact/static-contact.component.html
// module chunks = 0